import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import {
  CreateUserParams,
  CreateUserResponse,
  LeadDetails,
  createUser,
  createUserByUnlockContent,
} from '../utils/backend-api/users';

export default function useUserCreate(
  unlockContent: boolean,
  leadDetails: LeadDetails,
  toastMessageOnSuccess?: string
) {
  const submit = unlockContent ? createUserByUnlockContent : createUser;
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (params: CreateUserParams) => submit(params, leadDetails),
    {
      onSuccess: (response: CreateUserResponse) => {
        if (toastMessageOnSuccess) {
          toast.success(toastMessageOnSuccess);
          setTimeout(() => {
            window.location.href = response.location;
          }, 1000);
        } else {
          window.location.href = response.location;
        }
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
